import { render, staticRenderFns } from "./ShenbaoLogin.vue?vue&type=template&id=1abc9bfa&scoped=true"
import script from "./ShenbaoLogin.vue?vue&type=script&lang=js"
export * from "./ShenbaoLogin.vue?vue&type=script&lang=js"
import style0 from "./ShenbaoLogin.vue?vue&type=style&index=0&id=1abc9bfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abc9bfa",
  null
  
)

export default component.exports